import Landing from '../../Components/Landing';

const LandingPage = () => {
  return <Landing />;
};

export default LandingPage;
